/* eslint-disable */
import React, { useContext } from 'react';
import { Data, Filters } from '../contexts';
import { parseMoney } from '../../utils';
import { CommonSizeArrowsHelper, YTDNAICSFocusedVals, YTDPnlandBalCommonSizeValue, YTDPnlandBalValues } from '../report_components/MoneyHelpers';

const getYTDMonthCount = (data, ytdMonths) => {
  if (!data || !Array.isArray(ytdMonths)) return 0;
  return ytdMonths.filter((m) => _.isNumber(data[m])).length || 1;
};

const monthNames = {
  1: 'JAN',
  2: 'FEB',
  3: 'MAR',
  4: 'APR',
  5: 'MAY',
  6: 'JUN',
  7: 'JUL',
  8: 'AUG',
  9: 'SEP',
  10: 'OCT',
  11: 'NOV',
  12: 'DEC',
};

const MoneyYTD = ({ clientName, editMetrics, handleEditMetrics, handleSelectAndLayout, n, rows, sheet, title, ...props }) => {
  const { monthly_calcs, ytd_months } = useContext(Data);
  const { filters } = useContext(Filters);
  let finalFilters = props.tabFilters || filters;
  const reportPeriod = finalFilters.report_period;
  const avgCalcs = props.aggregateData ? props.aggregateData?.monthly?.avg : monthly_calcs?.avg;
  const docsAvgCalcs = props.aggregateData ? props.aggregateData?.monthly?.docs_avg : monthly_calcs?.docs_avg;
  const compareWith = finalFilters.compare_with;
  const selectedYear = finalFilters.year;
  const previousYear = finalFilters.year - 1
  const selectedYearEndDigits = selectedYear ? selectedYear.toString().slice(-2) : '';
  const previousYearEndDigits = previousYear ? previousYear.toString().slice(-2) : '';
  const numOfPeers = props.page === 'docs_pnl'
    ? (props.aggregateData?.monthly_docs_avg_n?.[selectedYear] ?? 0)
    : (props.aggregateData?.monthly_avg_n?.[selectedYear] ?? 0);

  let peerLabel = `n = ${numOfPeers}`
  if (finalFilters && compareWith === 'Default:YOY') {
    peerLabel = 'n = 1'
  } else if (finalFilters && compareWith === 'Default:None') {
    peerLabel = 'n = 0'
  }
  // Only two years being used for YTD tables.
  // Each month with values should have total revenue. Use to check how many months with values are available and label the YTD columns with the month/year.
  const previousYearYTDYouTotalRevenue = monthly_calcs?.you?.total_revenue?.[previousYear];
  const currentYearYTDYouTotalRevenue = monthly_calcs?.you?.total_revenue?.[selectedYear];
  const firstYearMonth = getYTDMonthCount(previousYearYTDYouTotalRevenue, ytd_months)
  const secondYearMonth = getYTDMonthCount(currentYearYTDYouTotalRevenue, ytd_months)
  const clientFirstYearMonth = firstYearMonth < 10 ? '0' + firstYearMonth.toString() : firstYearMonth;
  const clientSecondYearMonth = secondYearMonth < 10 ? '0' + secondYearMonth.toString() : secondYearMonth;

  const emptyYTDRow = (i, key = '', copy = '', relatedCheckedKey, padding = '', checked, displayChart, copyCellStyle, firstStyle, secondStyle) => {

    if (copy === 'Current Liabilities') {
      secondStyle.paddingTop = '20px';
    }
    if (props.page === 'docs_pnl' || key === 'space_before_revenue') {
      firstStyle.height = '20px';
      secondStyle.height = '20px';
    }

    const rowChecked = displayChart && checked && editMetrics && props.page === 'money' ? <p style={{ 'margin': 0 }}>&#10004;</p> : '';

    return (
      <tr
        key={Math.random(89)}
        onClick={() =>
          editMetrics ? handleSelectAndLayout('money', sheet, relatedCheckedKey) : null
        }
      >
        {props.page === 'money' && !props.pdf ? <td>{rowChecked}</td> : null}
        <td className={copyCellStyle} style={secondStyle}>
          {padding + copy}
        </td>
        <td className="money-table-cell" style={firstStyle} />
        <td className="money-table-cell" style={firstStyle} />
        {['Peers', 'Default:Peers'].includes(compareWith) ? <td className="money-table-cell" style={firstStyle} /> : null}
        {['Peers', 'Default:Peers'].includes(compareWith) ? <td className="money-table-cell" style={firstStyle} /> : null}
        <td style={secondStyle} />
        <td style={secondStyle} />
        <td style={secondStyle} />
        {['Peers', 'Default:Peers'].includes(compareWith) ? <td style={secondStyle} /> : null}
        {['Peers', 'Default:Peers'].includes(compareWith) ? <td style={secondStyle} /> : null}
        <td style={secondStyle} />
        <td className="money-table-cell" style={firstStyle} />
      </tr>
    );
  }

  const emptyMonthAndYTDRow = (i, key = '', copy = '', relatedCheckedKey, padding = '', checked, displayChart, copyCellClass, copyCellStyle, firstStyle, secondStyle) => {
    if (copy === 'Current Liabilities') {
      secondStyle.paddingTop = '20px';
    }
    if (props.page === 'docs_pnl' || key === 'space_before_revenue') {
      firstStyle.height = '20px';
      secondStyle.height = '20px';
    }

    const rowChecked = displayChart && checked && editMetrics && props.page === 'money' ? <p style={{ 'margin': 0 }}>&#10004;</p> : '';

    return (
      <tr
        key={Math.random(89)}
        onClick={() =>
          editMetrics ? handleSelectAndLayout('money', sheet, relatedCheckedKey) : null
        }
      >
        {props.page === 'money' && !props.pdf ? <td>{rowChecked}</td> : null}
        <td className={copyCellClass} style={copyCellStyle}>
          {padding + copy}
        </td>
        <td className="money-table-cell" style={firstStyle} />
        <td className="money-table-cell" style={firstStyle} />
        <td style={secondStyle} />
        {compareWith === 'Default:None' ? null : <td style={secondStyle} />}
        {compareWith === 'Default:None' ? null : <td style={secondStyle} />}
        {compareWith === 'Default:None' ? null : <td style={secondStyle} />}
        {compareWith === 'Default:None' ? null : <td className="money-table-cell" style={firstStyle} />}
        {compareWith === 'Default:None' ? null : <td className="money-table-cell" style={firstStyle} />}
        <td style={secondStyle} />
        <td style={secondStyle} />
        {compareWith === 'Default:None' ? null : <td style={secondStyle} />}
      </tr>
    );
  }

  const Total = (props) => {
    return (
      <td className={props.cssClass} style={props.style}>
        {parseMoney(props.value)}
      </td>
    );
  }

  const Delta = (props) => {
    return (
      <td className="money-table-cell" style={props.style}>
        {parseMoney(props.valueCurrentYear - props.valuePreviousYear)}
      </td>
    );
  }

  const rowStyles = (forecast, topline) => {
    let underlineFormat;
    let toplineFormat = topline ? 'solid 1px' : '';

    if (forecast) {
      if (forecast.total) {
        if (forecast.total.boldedUnderline) {
          underlineFormat = 'solid 2px';
        } else if (forecast.total.doubleUnderline) {
          underlineFormat = 'double 2px';
        } else if (forecast.total.underline) {
          underlineFormat = 'solid 1px';
        }

        toplineFormat = forecast.total.topline ? 'solid 1px' : '';
      } else {
        if (forecast.boldedUnderline) {
          underlineFormat = 'solid 2px';
        } else if (forecast.doubleUnderline) {
          underlineFormat = 'double 2px';
        } else if (forecast.underline) {
          underlineFormat = 'solid 1px';
        }

        toplineFormat = forecast.topline ? 'solid 1px' : '';
      }
    }

    const copyCellStyle = {
      fontWeight: 'bold',
      textAlign: 'left',
      borderBottom: underlineFormat,
      borderTop: toplineFormat,
    }

    const firstEmptyStyle = {
      fontWeight: 'bold',
      textAlign: 'left',
      borderBottom: underlineFormat,
      borderTop: toplineFormat,
      backgroundColor: '#BFE0AE',
      borderLeft: reportPeriod === 'CM + YTD' ? 'solid 1px' : null,
    };


    const secondEmptyStyle = {
      fontWeight: 'bold',
      textAlign: 'left',
      borderBottom: underlineFormat,
      borderTop: toplineFormat,
      borderLeft: reportPeriod === 'CM + YTD' ? 'solid 1px' : null,
    };

    const firstValueStyle = {
      textAlign: 'right',
      borderBottom: underlineFormat,
      borderTop: toplineFormat ? 'solid 1px' : '',
      backgroundColor: '#BFE0AE',
      borderLeft: reportPeriod === 'CM + YTD' ? 'solid 1px' : null,
    };

    const secondValueStyle = {
      textAlign: 'right',
      borderBottom: underlineFormat,
      borderTop: toplineFormat ? 'solid 1px' : '',
      borderLeft: reportPeriod === 'CM + YTD' ? 'solid 1px' : null,
    };

    return { copyCellStyle, firstEmptyStyle, secondEmptyStyle, firstValueStyle, secondValueStyle }
  }

  const rowData = (key, map_keys) => {
    let valuePreviousYear; let valueCurrentYear; let valuePreviousYearPeers; let valueCurrentYearPeers;
    let valuePYMonthlyCommonSize; let valuePYPeersMonthlyCommonSize; let valueCYMonthlyCommonSize; let valueCYPeersMonthlyCommonSize;
    let firstMonthVal; let secondMonthVal; let firstMonthValCS; let secondMonthValCS;
    let firstYear; let secondYear;

    // Individual Months
    if (reportPeriod === 'CM + YTD') {
      if (compareWith === 'Default:YOY') {
        firstYear = previousYear;
        secondYear = selectedYear;

        if (sheet === 'pnl' || ['people_financial_detail', 'customers_financial_detail', 'customers_kpi'].includes(sheet)) {
          firstMonthVal = monthly_calcs?.you?.[key]?.[firstYear]?.[firstYearMonth] || 0
          secondMonthVal = monthly_calcs?.you?.[key]?.[secondYear]?.[secondYearMonth] || 0
          let firstMonthRevenue = monthly_calcs?.you?.['total_revenue']?.[firstYear]?.[firstYearMonth] || 0
          let secondMonthRevenue = monthly_calcs?.you?.['total_revenue']?.[secondYear]?.[secondYearMonth] || 0
          firstMonthValCS = firstMonthRevenue ? firstMonthVal / firstMonthRevenue : 0
          secondMonthValCS = secondMonthRevenue ? secondMonthVal / secondMonthRevenue : 0
        }

        if (sheet === 'balance_sheet') {
          firstMonthVal = monthly_calcs?.you?.[key]?.[firstYear]?.[firstYearMonth] || 0
          secondMonthVal = monthly_calcs?.you?.[key]?.[secondYear]?.[secondYearMonth] || 0
          let firstMonthAsset = monthly_calcs?.you?.['total_assets']?.[firstYear]?.[firstYearMonth] || 0
          let secondMonthAsset = monthly_calcs?.you?.['total_assets']?.[secondYear]?.[secondYearMonth] || 0
          firstMonthValCS = firstMonthAsset ? firstMonthVal / firstMonthAsset : 0
          secondMonthValCS = secondMonthAsset ? secondMonthVal / secondMonthAsset : 0
        }

        if (props.page === 'docs_pnl') {
          firstMonthVal = YTDNAICSFocusedVals(props.naicsCode, key, map_keys, firstYear, [firstYearMonth], monthly_calcs?.you, rows)
          secondMonthVal = YTDNAICSFocusedVals(props.naicsCode, key, map_keys, secondYear, [secondYearMonth], monthly_calcs?.you, rows)
          firstMonthValCS = YTDPnlandBalCommonSizeValue(firstMonthVal, sheet, firstYear, [firstYearMonth], monthly_calcs?.you)
          secondMonthValCS = YTDPnlandBalCommonSizeValue(secondMonthVal, sheet, secondYear, [secondYearMonth], monthly_calcs?.you)
        }

      } else if (compareWith === 'Default:None') {
        firstYear = null;
        secondYear = selectedYear;

        if (sheet === 'pnl' || ['people_financial_detail', 'customers_financial_detail', 'customers_kpi'].includes(sheet)) {
          secondMonthVal = monthly_calcs?.you?.[key]?.[secondYear]?.[secondYearMonth] || 0
          let firstMonthRevenue = monthly_calcs?.you?.['total_revenue']?.[secondYear]?.[secondYearMonth] || 0
          secondMonthValCS = firstMonthRevenue ? secondMonthVal / firstMonthRevenue : 0
        }

        if (sheet === 'balance_sheet') {
          secondMonthVal = monthly_calcs?.you?.[key]?.[secondYear]?.[secondYearMonth] || 0
          let firstMonthAsset = monthly_calcs?.you?.['total_assets']?.[secondYear]?.[secondYearMonth] || 0
          secondMonthValCS = firstMonthAsset ? secondMonthVal / firstMonthAsset : 0
        }

        if (props.page === 'docs_pnl') {
          secondMonthVal = YTDNAICSFocusedVals(props.naicsCode, key, map_keys, secondYear, [secondYearMonth], monthly_calcs?.you, rows)
          secondMonthValCS = YTDPnlandBalCommonSizeValue(secondMonthVal, sheet, secondYear, [secondYearMonth], monthly_calcs?.you)
        }

      } else if (compareWith === 'Default:Peers') {
        firstYear = selectedYear;
        secondYear = selectedYear;

        if (sheet === 'pnl' || ['people_financial_detail', 'customers_financial_detail', 'customers_kpi'].includes(sheet)) {
          firstMonthVal = monthly_calcs?.you?.[key]?.[firstYear]?.[firstYearMonth] || 0
          secondMonthVal = avgCalcs?.[key]?.[secondYear]?.[secondYearMonth] || 0
          let firstMonthRevenue = monthly_calcs?.you?.['total_revenue']?.[firstYear]?.[firstYearMonth] || 0
          let secondMonthRevenue = avgCalcs?.['total_revenue']?.[secondYear]?.[secondYearMonth] || 0
          firstMonthValCS = firstMonthRevenue ? firstMonthVal / firstMonthRevenue : 0
          secondMonthValCS = secondMonthRevenue ? secondMonthVal / secondMonthRevenue : 0
        }

        if (sheet === 'balance_sheet') {
          firstMonthVal = monthly_calcs?.you?.[key]?.[firstYear]?.[firstYearMonth] || 0
          secondMonthVal = avgCalcs?.[key]?.[secondYear]?.[secondYearMonth] || 0
          let firstMonthAsset = monthly_calcs?.you?.['total_assets']?.[firstYear]?.[firstYearMonth] || 0
          let secondMonthAsset = avgCalcs?.['total_assets']?.[secondYear]?.[secondYearMonth] || 0
          firstMonthValCS = firstMonthAsset ? firstMonthVal / firstMonthAsset : 0
          secondMonthValCS = secondMonthAsset ? secondMonthVal / secondMonthAsset : 0
        }
      } else if (compareWith && compareWith.includes('Forecast')) {
        firstYear = selectedYear;
        secondYear = props.forecastVals?.['total_revenue'] ? Object.keys(props.forecastVals['total_revenue'])[0] : null

        if (sheet === 'pnl' || ['people_financial_detail', 'customers_financial_detail', 'customers_kpi'].includes(sheet)) {
          firstMonthVal = monthly_calcs?.you?.[key]?.[firstYear]?.[firstYearMonth] || 0
          secondMonthVal = props.forecastVals?.[key]?.[secondYear]?.[secondYearMonth] || 0
          let firstMonthRevenue = monthly_calcs?.you?.['total_revenue']?.[firstYear]?.[firstYearMonth] || 0
          let secondMonthRevenue = props.forecastVals?.['total_revenue']?.[secondYear]?.[secondYearMonth] || 0
          firstMonthValCS = firstMonthRevenue ? firstMonthVal / firstMonthRevenue : 0
          secondMonthValCS = secondMonthRevenue ? secondMonthVal / secondMonthRevenue : 0
        }

        if (sheet === 'balance_sheet') {
          firstMonthVal = monthly_calcs?.you?.[key]?.[firstYear]?.[firstYearMonth] || 0
          secondMonthVal = props.forecastVals?.[key]?.[secondYear]?.[secondYearMonth] || 0
          let firstMonthAsset = monthly_calcs?.you?.['total_assets']?.[firstYear]?.[firstYearMonth] || 0
          let secondMonthAsset = props.forecastVals?.['total_assets']?.[secondYear]?.[secondYearMonth] || 0
          firstMonthValCS = firstMonthAsset ? firstMonthVal / firstMonthAsset : 0
          secondMonthValCS = secondMonthAsset ? secondMonthVal / secondMonthAsset : 0
        }
      }

      // + YTD Values
      if (props.page === 'docs_pnl') {
        valuePreviousYear = YTDNAICSFocusedVals(props.naicsCode, key, map_keys, firstYear, ytd_months, monthly_calcs?.you, rows)
        valuePYMonthlyCommonSize = YTDPnlandBalCommonSizeValue(valuePreviousYear, sheet, firstYear, ytd_months, monthly_calcs?.you)
        
        if (['Peers', 'Default:Peers'].includes(compareWith)) {
          valueCurrentYear = YTDNAICSFocusedVals(props.naicsCode, key, map_keys, firstYear, ytd_months, docsAvgCalcs, rows)
          valueCYMonthlyCommonSize = YTDPnlandBalCommonSizeValue(valueCurrentYear, sheet, firstYear, ytd_months, docsAvgCalcs)
        } else if (compareWith && compareWith.includes('Forecast')) {
          valueCurrentYear = YTDNAICSFocusedVals(props.naicsCode, key, map_keys, secondYear, ytd_months, props.forecastVals, rows)
          valueCYMonthlyCommonSize = YTDPnlandBalCommonSizeValue(valueCurrentYear, sheet, secondYear, ytd_months, props.forecastVals)
        } else {
          valueCurrentYear = YTDNAICSFocusedVals(props.naicsCode, key, map_keys, secondYear, ytd_months, monthly_calcs?.you, rows)
          valueCYMonthlyCommonSize = YTDPnlandBalCommonSizeValue(valueCurrentYear, sheet, secondYear, ytd_months, monthly_calcs?.you)
        }

      } else {
        const previousYearNonMonthlyYTDYou = monthly_calcs?.you?.[key]?.[firstYear];
        const currentYearNonMonthlyYTDYou = monthly_calcs?.you?.[key]?.[secondYear];
  
        valuePreviousYear = YTDPnlandBalValues(sheet, key, previousYearNonMonthlyYTDYou, firstYear, ytd_months, monthly_calcs?.you)
        valuePYMonthlyCommonSize = YTDPnlandBalCommonSizeValue(valuePreviousYear, sheet, firstYear, ytd_months, monthly_calcs?.you)

        if (['Peers', 'Default:Peers'].includes(compareWith)) {
          const currentYearNonMonthlyYTDPeers = avgCalcs?.[key]?.[firstYear];
          valueCurrentYear = YTDPnlandBalValues(sheet, key, currentYearNonMonthlyYTDPeers, firstYear, ytd_months, avgCalcs)
          valueCYMonthlyCommonSize = YTDPnlandBalCommonSizeValue(valueCurrentYear, sheet, firstYear, ytd_months, avgCalcs)
        } else if (compareWith && compareWith.includes('Forecast')) {
          const currentYearNonMonthlyYTDForecast = props.forecastVals?.[key]?.[secondYear];
          valueCurrentYear = YTDPnlandBalValues(sheet, key, currentYearNonMonthlyYTDForecast, secondYear, ytd_months, props.forecastVals)
          valueCYMonthlyCommonSize = YTDPnlandBalCommonSizeValue(valueCurrentYear, sheet, secondYear, ytd_months, props.forecastVals)
        } else {
          valueCurrentYear = YTDPnlandBalValues(sheet, key, currentYearNonMonthlyYTDYou, secondYear, ytd_months, monthly_calcs?.you)
          valueCYMonthlyCommonSize = YTDPnlandBalCommonSizeValue(valueCurrentYear, sheet, secondYear, ytd_months, monthly_calcs?.you)
        }
      }

    } else {
      // All Year to Date values
      firstYear = previousYear;
      secondYear = selectedYear;
      if (props.page === 'docs_pnl') {
        valuePreviousYear = YTDNAICSFocusedVals(props.naicsCode, key, map_keys, firstYear, ytd_months, monthly_calcs?.you, rows)
        valueCurrentYear = YTDNAICSFocusedVals(props.naicsCode, key, map_keys, secondYear, ytd_months, monthly_calcs?.you, rows)
        valuePYMonthlyCommonSize = YTDPnlandBalCommonSizeValue(valuePreviousYear, sheet, firstYear, ytd_months, monthly_calcs?.you)
        valueCYMonthlyCommonSize = YTDPnlandBalCommonSizeValue(valueCurrentYear, sheet, secondYear, ytd_months, monthly_calcs?.you)
  
        if (['Peers', 'Default:Peers'].includes(compareWith)) {
          valuePreviousYearPeers = YTDNAICSFocusedVals(props.naicsCode, key, map_keys, firstYear, ytd_months, docsAvgCalcs, rows)
          valueCurrentYearPeers = YTDNAICSFocusedVals(props.naicsCode, key, map_keys, secondYear, ytd_months, docsAvgCalcs, rows)
          valuePYPeersMonthlyCommonSize = YTDPnlandBalCommonSizeValue(valuePreviousYearPeers, sheet, firstYear, ytd_months, docsAvgCalcs)
          valueCYPeersMonthlyCommonSize = YTDPnlandBalCommonSizeValue(valueCurrentYearPeers, sheet, secondYear, ytd_months, docsAvgCalcs)
        }
      } else {
        const previousYearNonMonthlyYTDYou = monthly_calcs?.you?.[key]?.[firstYear];
        const currentYearNonMonthlyYTDYou = monthly_calcs?.you?.[key]?.[secondYear];
  
        valuePreviousYear = YTDPnlandBalValues(sheet, key, previousYearNonMonthlyYTDYou, firstYear, ytd_months, monthly_calcs?.you)
        valueCurrentYear = YTDPnlandBalValues(sheet, key, currentYearNonMonthlyYTDYou, secondYear, ytd_months, monthly_calcs?.you)
        valuePYMonthlyCommonSize = YTDPnlandBalCommonSizeValue(valuePreviousYear, sheet, firstYear, ytd_months, monthly_calcs?.you)
        valueCYMonthlyCommonSize = YTDPnlandBalCommonSizeValue(valueCurrentYear, sheet, secondYear, ytd_months, monthly_calcs?.you)
  
        if (['Peers', 'Default:Peers'].includes(compareWith)) {
          const previousYearNonMonthlyYTDPeers = avgCalcs?.[key]?.[firstYear];
          const currentYearNonMonthlyYTDPeers = avgCalcs?.[key]?.[secondYear];
          valuePreviousYearPeers = YTDPnlandBalValues(sheet, key, previousYearNonMonthlyYTDPeers, firstYear, ytd_months, avgCalcs)
          valueCurrentYearPeers = YTDPnlandBalValues(sheet, key, currentYearNonMonthlyYTDPeers, secondYear, ytd_months, avgCalcs)
          valuePYPeersMonthlyCommonSize = YTDPnlandBalCommonSizeValue(valuePreviousYearPeers, sheet, firstYear, ytd_months, avgCalcs)
          valueCYPeersMonthlyCommonSize = YTDPnlandBalCommonSizeValue(valueCurrentYearPeers, sheet, secondYear, ytd_months, avgCalcs)
        }
      }
    }

    return { firstMonthVal, secondMonthVal, firstMonthValCS, secondMonthValCS, valuePreviousYear, valueCurrentYear, valuePreviousYearPeers, valueCurrentYearPeers, valuePYMonthlyCommonSize, valuePYPeersMonthlyCommonSize, valueCYMonthlyCommonSize, valueCYPeersMonthlyCommonSize }
  }

  const buildMonthAndYTDRow = ({ i = '', header = '', header_is_total = false, key = '', header_key = '', relatedCheckedKey = '', copy = '', padding = '', bold = '', forecast = '', checked = false, displayChart = '', map_keys = [], emptyRow = false, topline = '', whiteSpace = '', alwaysDisplayRow = false }) => {
    const copyCellClass = whiteSpace ? 'account-column wrap-copy-cell' : 'account-column';
    const { copyCellStyle, firstEmptyStyle, secondEmptyStyle, firstValueStyle, secondValueStyle } = rowStyles(forecast, topline);
    const passedCalcsPrevYear = props.page === 'docs_pnl' ? docsAvgCalcs : avgCalcs;
    const passedCalcsCurrentYear = props.page === 'docs_pnl' ? docsAvgCalcs : avgCalcs;

    if (((header || header_key || emptyRow) && !header_is_total) || emptyRow) return emptyMonthAndYTDRow(i, key, copy, relatedCheckedKey, padding, checked, displayChart, copyCellClass, copyCellStyle, firstEmptyStyle, secondEmptyStyle);
    const { firstMonthVal, secondMonthVal, firstMonthValCS, secondMonthValCS, valuePreviousYear, valueCurrentYear, valuePreviousYearPeers, valueCurrentYearPeers, valuePYMonthlyCommonSize, valuePYPeersMonthlyCommonSize, valueCYMonthlyCommonSize, valueCYPeersMonthlyCommonSize } = rowData(key, map_keys)

    const comparisonPY = valuePYPeersMonthlyCommonSize === '0.00' || valuePYPeersMonthlyCommonSize === undefined ? true : null
    const comparisonCY = valueCYPeersMonthlyCommonSize === '0.00' || valueCYPeersMonthlyCommonSize === undefined ? true : null
    const hideRow = valuePreviousYear === 0 && comparisonPY && valueCurrentYear === 0 && comparisonCY && !alwaysDisplayRow ? copy : null
    const rowChecked = displayChart && checked && editMetrics ? <p style={{ 'margin': 0 }}>&#10004;</p> : '';
  
    let cellClass = ''
    if (compareWith === 'Default:Peers') {
      cellClass = 'money-table-cell'
    } else if (compareWith && compareWith.includes('Forecast')) {
      cellClass = 'money-table-cell'
    }

    if (compareWith === 'Default:None') {
      return (
        <tr
          key={Math.random(89)}
          id={`${sheet}-mom-ytd-row-${i}`}
          style={hideRow === copy ? { display: 'none' } : {}}
          onClick={() =>
            editMetrics ? handleSelectAndLayout('money', sheet, relatedCheckedKey) : null
          }
        >
          {props.page === 'money' && !props.pdf ? <td>{rowChecked}</td> : null}
          {copy === 'Current Liabilities' ? (
            <td className={copyCellClass} style={{ paddingTop: '20px' }}>
              {padding + copy}
            </td>
          ) : (
            <td className={copyCellClass} style={copyCellStyle}>
              {padding + copy}
            </td>
          )}
          <td style={secondValueStyle} className="money-table-cell">{parseMoney(secondMonthVal)}</td>
          <td style={secondValueStyle} className="common-size-cell money-table-cell">{secondMonthValCS ? `${(secondMonthValCS * 100).toFixed(1)}%` : '-'}</td>
          <td style={secondValueStyle}></td>
          <Total cssClass={''} value={valueCurrentYear} style={secondValueStyle} />
          <td className="common-size-cell" style={secondValueStyle}>{valueCYMonthlyCommonSize ? `${(valueCYMonthlyCommonSize * 100).toFixed(1)}%` : '-'}</td>
        </tr>
      );
    } else {
      return (
        <tr
          key={Math.random(89)}
          id={`${sheet}-mom-ytd-row-${i}`}
          style={hideRow === copy ? { display: 'none' } : {}}
          onClick={() =>
            editMetrics ? handleSelectAndLayout('money', sheet, relatedCheckedKey) : null
          }
        >
          {props.page === 'money' && !props.pdf ? <td>{rowChecked}</td> : null}
          {copy === 'Current Liabilities' ? (
            <td className={copyCellClass} style={{ paddingTop: '20px' }}>
              {padding + copy}
            </td>
          ) : (
            <td className={copyCellClass} style={copyCellStyle}>
              {padding + copy}
            </td>
          )}
          <td style={secondValueStyle} className="money-table-cell">{parseMoney(firstMonthVal)}</td>
          <td style={secondValueStyle} className="common-size-cell money-table-cell">{firstMonthValCS ? `${(firstMonthValCS * 100).toFixed(1)}%` : '-'}</td>
          <td style={secondValueStyle} />
          <td style={secondValueStyle}>{parseMoney(secondMonthVal)}</td>
          <td style={secondValueStyle} className="common-size-cell">{secondMonthValCS ? `${(secondMonthValCS * 100).toFixed(1)}%` : '-'}</td>
          <td style={secondValueStyle}></td>
          <Total cssClass={'money-table-cell'} value={valuePreviousYear} style={firstValueStyle} />
          <td className={`common-size-cell money-table-cell`} style={firstValueStyle}>
            {valuePYMonthlyCommonSize ? `${(valuePYMonthlyCommonSize * 100).toFixed(1)}%` : '-'}
          </td>
          <td style={secondValueStyle}></td>
          <Total cssClass={''} value={valueCurrentYear} style={secondValueStyle} />
          <td className="common-size-cell" style={secondValueStyle}>{valueCYMonthlyCommonSize ? `${(valueCYMonthlyCommonSize * 100).toFixed(1)}%` : '-'}</td>
        </tr>
      );
    }
  }

  let totalLiabAndEqVals, netWorthVals;
  const buildYTDRow = ({ i = '', header = '', key = '', header_key = '', relatedCheckedKey = '', copy = '', padding = '', bold = '', forecast = '', checked = false, displayChart = '', map_keys = [], emptyRow = false, topline = '', whiteSpace = '', alwaysDisplayRow = false }) => {
    const copyCellStyle = whiteSpace ? 'account-column wrap-copy-cell' : 'account-column';
    const { firstEmptyStyle, secondEmptyStyle, firstValueStyle, secondValueStyle } = rowStyles(forecast, topline);

    const passedCalcsPrevYear = props.page === 'docs_pnl' ? docsAvgCalcs : avgCalcs;
    const passedCalcsCurrentYear = props.page === 'docs_pnl' ? docsAvgCalcs : avgCalcs;

    if (header || header_key || emptyRow) return emptyYTDRow(i, key, copy, relatedCheckedKey, padding, checked, displayChart, copyCellStyle, firstEmptyStyle, secondEmptyStyle);

    const { valuePreviousYear, valueCurrentYear, valuePreviousYearPeers, valueCurrentYearPeers, valuePYMonthlyCommonSize, valuePYPeersMonthlyCommonSize, valueCYMonthlyCommonSize, valueCYPeersMonthlyCommonSize } = rowData(key, map_keys)

    const comparisonPY = valuePYPeersMonthlyCommonSize === '0.00' || valuePYPeersMonthlyCommonSize === undefined ? true : null
    const comparisonCY = valueCYPeersMonthlyCommonSize === '0.00' || valueCYPeersMonthlyCommonSize === undefined ? true : null
    const hideRow = valuePreviousYear === 0 && comparisonPY && valueCurrentYear === 0 && comparisonCY && !alwaysDisplayRow ? copy : null
    const rowChecked = displayChart && checked && editMetrics ? <p style={{ 'margin': 0 }}>&#10004;</p> : '';

    return (
      <tr
        key={Math.random(89)}
        id={`${sheet}-report-row-${i}`}
        style={hideRow === copy ? { display: 'none' } : {}}
        onClick={() =>
          editMetrics ? handleSelectAndLayout('money', sheet, relatedCheckedKey) : null
        }
      >
        {props.page === 'money' && !props.pdf ? <td>{rowChecked}</td> : null}
        {copy === 'Current Liabilities' ? (
          <td className={copyCellStyle} style={{ paddingTop: '20px' }}>
            {padding + copy}
          </td>
        ) : (
          <td className={copyCellStyle} style={secondEmptyStyle}>
            {padding + copy}
          </td>
        )}
        <Total cssClass={'money-table-cell'} value={valuePreviousYear} style={firstValueStyle} />
        <td className="common-size-cell money-table-cell" style={firstValueStyle}>
          {valuePYMonthlyCommonSize ? `${(valuePYMonthlyCommonSize * 100).toFixed(1)}%` : '-'}
        </td>
        {['Peers', 'Default:Peers'].includes(compareWith) ? (
          <CommonSizeArrowsHelper
            cssClass="money-table-cell"
            display="ytd"
            youTotRev={monthly_calcs?.you?.['total_revenue']?.[previousYear]}
            youTotAssets={monthly_calcs?.you?.['total_assets']?.[previousYear]}
            valueYou={valuePreviousYear}
            valueCompareTo={valuePreviousYearPeers}
            style={firstValueStyle}
            sheet={sheet}
            keyArrBuilder={key}
            ytdMonths={ytd_months}
            selectedYear={previousYear}
            passedCalcs={passedCalcsPrevYear}
          />
        ) : null}
        {['Peers', 'Default:Peers'].includes(compareWith) ? (
          <td className="common-size-cell money-table-cell" style={firstValueStyle}>
            {valuePYPeersMonthlyCommonSize
              ? (valuePYPeersMonthlyCommonSize * 100).toFixed(1) + '%'
              : '-'}
          </td>
        ) : null}
        <td style={secondValueStyle} />
        <Total cssClass={''} value={valueCurrentYear} style={secondValueStyle} />
        <td className="common-size-cell" style={secondValueStyle}>
          {valueCYMonthlyCommonSize ? `${(valueCYMonthlyCommonSize * 100).toFixed(1)}%` : '-'}
        </td>
        {['Peers', 'Default:Peers'].includes(compareWith) ? (
          <CommonSizeArrowsHelper
            cssClass=""
            display="ytd"
            youTotRev={monthly_calcs?.you?.['total_revenue']?.[selectedYear]}
            youTotAssets={monthly_calcs?.you?.['total_assets']?.[selectedYear]}
            valueYou={valueCurrentYear}
            valueCompareTo={valueCurrentYearPeers}
            style={secondValueStyle}
            sheet={sheet}
            keyArrBuilder={key}
            ytdMonths={ytd_months}
            selectedYear={selectedYear}
            passedCalcs={passedCalcsCurrentYear}
          />
        ) : null}
        {['Peers', 'Default:Peers'].includes(compareWith) ? (
          <td className="common-size-cell" style={secondValueStyle}>
            {valueCYPeersMonthlyCommonSize
              ? (valueCYPeersMonthlyCommonSize * 100).toFixed(1) + '%'
              : '-'}
          </td>
        ) : null}
        <td style={secondValueStyle} />
        <Delta
          valuePreviousYear={valuePreviousYear}
          valueCurrentYear={valueCurrentYear}
          style={firstValueStyle}
        />
      </tr>
    );
  }

  const tableRows = [];
  if (sheet === 'pnl' && props.naicsCode && props.naicsCode.startsWith('621')) {
    const healthCareRevenueChildKeys = [
      { key: 'total_revenue_gross_charges', copy: 'Gross Charges' },
      { key: 'total_revenue_adjustments', copy: 'Adjustments' }
    ];

    let existingKey;
    healthCareRevenueChildKeys.forEach((k) => {
      existingKey = rows.find(r => r.key === k.key);
      if (!existingKey) {
        if (reportPeriod === 'CM + YTD') {
          tableRows.push(
            buildMonthAndYTDRow({
              key: k.key,
              copy: k.copy,
              header: false,
              padding: '',
              parentKey: 'total_revenue',
              sheet: 'pnl',
              commonKey: 'revenue',
              alwaysDisplayRow: true,
            }),
          );
        } else {
          tableRows.push(
            buildYTDRow({
              key: k.key,
              copy: k.copy,
              header: false,
              padding: '',
              parentKey: 'total_revenue',
              sheet: 'pnl',
              commonKey: 'revenue',
              alwaysDisplayRow: true,
            }),
          );
        }
      }
    });
    if (!existingKey) {
      if (reportPeriod === 'CM + YTD') {
      tableRows.push(
        buildMonthAndYTDRow({
          key: 'space_before_revenue',
          copy: '',
          header: false,
          padding: '',
          sheet: 'pnl',
          emptyRow: true,
        }),
      );
      } else {
        tableRows.push(
          buildYTDRow({
            key: 'space_before_revenue',
            copy: '',
            header: false,
            padding: '',
            sheet: 'pnl',
            emptyRow: true,
          }),
        );
      }
    }
  }

  rows.forEach((row) => {
    if (reportPeriod === 'CM + YTD') {
      tableRows.push(buildMonthAndYTDRow(row))
    } else {
      tableRows.push(buildYTDRow(row));
    }
  });

  const buildHeader = () => {
    if (reportPeriod === 'CM + YTD') {
      if (compareWith === 'Default:YOY') {
        return (
          <tr>
            {props.page === 'money' && !props.pdf ? (<td className='edit-metrics-cell' onClick={() => handleEditMetrics()}>{editMetrics ? <i className='fa fa-save hide-on-print' style={{ 'fontSize': '2em' }}></i> : <i className='fa fa-pencil edit-icon hide-on-print' style={{ 'fontSize': '2em' }}></i>}</td>) : null}
            <td style={{ 'borderBottom': '1px solid'}} ></td>
            <td className='' style={{ 'borderBottom': '1px solid', 'borderLeft': '1px solid' }}>{`${monthNames[firstYearMonth]} ${previousYearEndDigits}`}</td>
            <td className='common-size-cell' style={{ 'borderBottom': '1px solid'}} >You</td>
            <td style={{ 'borderBottom': '1px solid', 'borderLeft': '1px solid' }}></td>
            <td style={{ 'borderBottom': '1px solid', 'borderLeft': '1px solid' }}>{`${monthNames[secondYearMonth]} ${selectedYearEndDigits}`}</td>
            <td className='common-size-cell' style={{ 'borderBottom': '1px solid' }}>You</td>
            <td style={{ 'borderBottom': '1px solid', 'borderLeft': '1px solid' }}></td>
            <td className='' style={{ 'borderBottom': '1px solid', 'borderLeft': '1px solid' }}>{`YTD ${previousYearEndDigits}`}</td>
            <td className='common-size-cell' style={{ 'borderBottom': '1px solid'}} >You</td>
            <td style={{ 'borderBottom': '1px solid', 'borderLeft': '1px solid' }}></td>
            <td style={{ 'borderBottom': '1px solid', 'borderLeft': '1px solid' }}>{`YTD ${selectedYearEndDigits}`}</td>
            <td className='common-size-cell' style={{ 'borderBottom': '1px solid' }}>You</td>
          </tr>
        )
      } else {
        let compareTitle = null;
        let cellStyle = { 'borderBottom': '1px solid', 'borderLeft': '1px solid' }
        let cellClass = ''
        if (compareWith === 'Default:Peers') {
          compareTitle = 'Peers'
        } else if (compareWith && compareWith.includes('Forecast')) {
          compareTitle = props.monthlyCompareWithTitle
        }

        return (
          <tr>
            {props.page === 'money' && !props.pdf ? (<td className='edit-metrics-cell' onClick={() => handleEditMetrics()}>{editMetrics ? <i className='fa fa-save hide-on-print' style={{ 'fontSize': '2em' }}></i> : <i className='fa fa-pencil edit-icon hide-on-print' style={{ 'fontSize': '2em' }}></i>}</td>) : null}
            <td style={{ 'borderBottom': '1px solid' }}></td>
            <td className='' style={{ 'borderBottom': '1px solid', 'borderLeft': '1px solid' }}>{`${monthNames[secondYearMonth]} ${selectedYearEndDigits}`}</td>
            <td className='common-size-cell' style={{ 'borderBottom': '1px solid' }}>You</td>
            <td style={{ 'borderBottom': '1px solid', 'borderLeft': '1px solid' }}></td>
            {compareWith === 'Default:None' ? null : <td style={{ 'borderBottom': '1px solid', 'borderLeft': '1px solid' }}>{`${monthNames[secondYearMonth]} ${selectedYearEndDigits}`}</td>}
            {compareWith === 'Default:None' ? null : <td className='common-size-cell' style={{ 'borderBottom': '1px solid' }}>{compareTitle}</td>}
            {compareWith === 'Default:None' ? null : <td style={{ 'borderBottom': '1px solid', 'borderLeft': '1px solid' }}></td>}
            <td className={cellClass} style={cellStyle}>{`YTD ${selectedYearEndDigits}`}</td>
            <td className={`common-size-cell ${cellClass}`} style={{ 'borderBottom': '1px solid' }}>You</td>
            {compareWith === 'Default:None' ? null : <td style={{ 'borderBottom': '1px solid', 'borderLeft': '1px solid' }}></td>}
            {compareWith === 'Default:None' ? null : <td style={{ 'borderBottom': '1px solid', 'borderLeft': '1px solid' }}>{`YTD ${selectedYearEndDigits}`}</td>}
            {compareWith === 'Default:None' ? null : <td className='common-size-cell' style={{ 'borderBottom': '1px solid' }}>{compareTitle}</td>}
          </tr>
        )
      }
    } else {
      return (
        <tr>
          {props.page === 'money' && !props.pdf ? (<td className='edit-metrics-cell' onClick={() => handleEditMetrics()}>{editMetrics ? <i className='fa fa-save hide-on-print' style={{ 'fontSize': '2em' }}></i> : <i className='fa fa-pencil edit-icon hide-on-print' style={{ 'fontSize': '2em' }}></i>}</td>) : null}
          <td></td>
          <td className='money-table-cell' style={{ 'backgroundColor': '#BFE0AE' }}>{`YTD ${clientFirstYearMonth}/${previousYear}`}</td>
          <td className='common-size-cell money-table-cell' style={{ 'backgroundColor': '#BFE0AE' }}>You</td>
          {['Peers', 'Default:Peers'].includes(compareWith) ? <td className='common-size-cell money-table-cell' style={{ 'backgroundColor': '#BFE0AE' }}></td> : null}
          {['Peers', 'Default:Peers'].includes(compareWith) ? <td className='common-size-cell money-table-cell' style={{ 'backgroundColor': '#BFE0AE' }}>Peers</td> : null}
          <td></td>
          <td>{`YTD ${clientSecondYearMonth}/${selectedYear}`}</td>
          <td className='common-size-cell'>You</td>
          {['Peers', 'Default:Peers'].includes(compareWith) ? <td className='common-size-cell'></td> : null}
          {['Peers', 'Default:Peers'].includes(compareWith) ? <td className='common-size-cell'>Peers</td> : null}
          <td></td>
          <td className='money-table-cell' style={{ 'backgroundColor': '#BFE0AE' }}>Δ Delta</td>
        </tr>
      )
    }
  }

  const tableID = props.page !== 'docs_pnl' ? `${sheet}-ytd` : 'docs_pnl-ytd'

  const buildYTDTable = () => {
    if (props.pdf) {
      let pageViewClass = 'portrait-view'
      let clientNames = props.realName ? `${props.realName} / ${clientName}` : clientName
      const tabName = (props.tabName || props.title || '').trim().toLowerCase();
      const title = (props.title || '').trim().toLowerCase();
      let reportTitle = tabName.includes(title) ? props.tabName || props.title : `${props.tabName}, ${props.title} Benchmark Report`;
      let naicsCode = finalFilters.code;
      let dataType = finalFilters.datatype;
      let revenueBand = finalFilters.revenue_band;
      let region = finalFilters.region;
      let numOfDocs = finalFilters.number_of_pros || 'All'
      let reportPeriod = finalFilters.report_period;
      const compareParts = finalFilters.compare_with.split(':');
      let compare = compareParts.length > 1 ? compareParts.slice(1).join(':').trim() : finalFilters.compare_with;
      let filtersTitle = props.page === 'docs_pnl' || props.page === 'docs_pnl-moneypdf' ? `NAICS: ${naicsCode}, Data Type: ${dataType}, Revenue: ${revenueBand}, Region: ${region}, # of Doctors: ${numOfDocs}, Report Period: ${reportPeriod}, Compare with: ${compare}` : `NAICS: ${naicsCode}, Data Type: ${dataType}, Revenue: ${revenueBand}, Region: ${region}, Report Period: ${reportPeriod}, Compare with: ${compare}`;

      return (
        <div className={pageViewClass}>
          <div className='money-pdf-portrait'>
            <div>
              <div className='money-pdf-table-div'>
                <div style={{'paddingBottom': '15px'}}>
                  <p className='report-annual-title'>{`${reportTitle}, ${clientNames}`}</p>
                  <p className='report-filters-title'>{filtersTitle}</p>
                </div>
                <table className='report-table sheets' id='docs_pnl-ytd-pdf'>
                  <thead>
                    {buildHeader()}
                  </thead>
                  <tbody>
                    {tableRows}
                    <tr><td className='footer-cell'><i>{peerLabel}</i></td></tr>
                  </tbody>
                </table>
                {props.page === 'docs_pnl' || props.page === 'docs_pnl-moneypdf' ? <p className='doctor-asterisk-note'>*The sub-accounts might not add up to total account if details are not provided.</p> : null}
              </div>
            </div>
            <p className='pdf-disclaimer-text'>{`These financial statements have been prepared by ${props.firmName}, and have not been subjected to an audit or review or compilation engagement, and no assurance is provided on them. These financial statements are intended for management’s internal use only. Substantially all disclosures omitted.`}</p>
          </div>
        </div>
      )
    }
    return (
      <div className='money-report-card monthly-sheet'>
        <div className='money-report-container'>
          <table className='report-table sheets' id={tableID}>
            <thead>
              {buildHeader()}
            </thead>
            <tbody>
              {tableRows}
            </tbody>
            <tfoot>
              <tr><td><i>{peerLabel}</i></td></tr>
            </tfoot>
          </table>
          {props.page === 'docs_pnl' || props.page === 'docs_pnl-moneypdf' ? <p className='doctor-asterisk-note'>*The sub-accounts might not add up to total account if details are not provided.</p> : null}
        </div>
      </div>
    )

  }

  return buildYTDTable();
};

export default MoneyYTD;
